import { render, staticRenderFns } from "./TaskCardList.vue?vue&type=template&id=5a6929b5&scoped=true&"
import script from "./TaskCardList.vue?vue&type=script&lang=js&"
export * from "./TaskCardList.vue?vue&type=script&lang=js&"
import style0 from "./TaskCardList.vue?vue&type=style&index=0&id=5a6929b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6929b5",
  null
  
)

export default component.exports